<template>
    <tr>
      <td data-label="Reference #">
        <router-link :to="{ path: '/quote/' + quote.uuid }" >
          <strong>
            {{ quote.reference }}
          </strong>
        </router-link>
        <br/>
        <template v-if="quote.isQuoteRejected">
          <strong >New Quote </strong>
          <router-link :to="{ path: '/quote/' + quote.NewQuoteUuid }" >
            <strong>
              {{ quote.NewQuote ? quote.NewQuote.reference : ''}}
            </strong>
          </router-link>
        </template>
      </td>
      <td data-label="Status">
        <span :class="status.completed.class" class="badge">
          {{ status.completed.text }}
        </span>
        <br/>
        <span :class="status.assigned.class" class="badge">
          {{ status.assigned.text }}
        </span>
        <br/>
        <span :class="status.queue.class" class="badge">
          {{ status.queue.text }}
        </span>
        <br/>
        <span class="badge-default badge">
          {{ propertyTypeName }}
        </span>
      </td>
      <td data-label="Property Address">
        {{ quote.address }}
      </td>
      <td data-label="Quote Type">
        {{ quote.QuoteType.quoteName }}
      </td>
      <td data-label="Requested">
        {{ quote.Customer.dropdownLabel }} <br/>
        <span class="text-muted">{{ dateRequested }}</span>
      </td>
      <td data-label="Assigned To">
        <template v-if="quote.ReportAssignedTo"> 
          {{ quote.ReportAssignedTo.dropdownLabel }} <br/>
          <span class="text-muted">{{ dateAssigned }}</span>
        </template> 
      </td>
      <td data-label="Live Feed">
        <router-link :to="{ path: '/liveFeed?QuoteUuid=' + quote.uuid }" >
          Live Feed
        </router-link>
      </td>
      <td class="button-2 text-center">
        <button
          :disabled="quote.isQuoteRejected"
          @click="report()"
          class="my-1 btn btn-warning">
          <i class="fa fa-fw fa-file-alt" /> Report
        </button>
        <button v-if="hasAdminPrivilege"
          @click="assignQuote()"
          class="my-1 btn btn-primary">
          <i class="fa fa-fw fa-id-badge" /> Assign Quote
        </button>
        <button
          :disabled="quote.isReportCompleted || quote.isQuoteRejected"
          @click="complete()"
          class="my-1 btn btn-success">
          <i class="fa fa-fw fa-check" /> Complete Report
        </button>
        <button v-if="hasAdminPrivilege"
          :disabled="quote.isQuoteRejected || quote.isQualityAssured"
          class="my-1 btn btn-danger"
          @click="reject()">
          <i class="far fa-fw fa-trash-alt" /> Reject and Create New
        </button>
        <router-link v-if="quote.QuoteReport"
          target="_blank"
          :to="{ path: '/api/public/pdf/' + quote.uuid + '?m=QuoteReport' }"
          class="my-1 btn btn-info">
          <i class="fa fa-fw fa-eye" /> Report Preview
        </router-link>
        <button v-if="hasAdminPrivilege"
          :disabled="!quote.isReportCompleted || quote.isQualityAssured"
          @click="assureQuality()"
          class="my-1 btn btn-success">
          <i class="fa fa-fw fa-clipboard-check" /> Assure Quality
        </button>
        <button
          v-if="quote.isQualityAssured && !quote.isQuoteRejected && hasAdminPrivilege"
          class="my-1 btn btn-primary"
          @click="send()">
          <i class="far fa-fw fa-paper-plane" /> Email Report
        </button>
        <download-input
          v-if="quote.QuotePdf"
          :options="{ button: true, permalink: 'downloadFile', label: 'Quote Download' }"
          :value="{ objectKey: quote.QuotePdf ? quote.QuotePdf.objectKey : '' }" />
        <router-link v-if="quote.QuotePdf"
          target="_blank"
          :to="{ path: '/api/public/pdf/' + quote.uuid + '?m=Quote' }"
          class="my-1 btn btn-info">
          <i class="fa fa-fw fa-search" /> Quote Preview
        </router-link>
      </td>
    </tr>

</template>

<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  import {
    SEND_REPORT,
    REJECT_AND_CREATE_QUOTE,
    ASSURE_QUALITY,
    ASSIGN_QUOTE,
    COMPLETE_REPORT
  } from '@/vuex/types'
  export default {
    name: 'ApprovedQuoteRow',
    props: {
      object: {
        type: Object
      }
    },
    components: {
      DownloadInput
    },
    data () {
      return {
        completed: { class: 'badge-default', text: 'Started' },
        queue: { class: 'badge-default', text: 'Normal' },
        assigned: { class: 'badge-default', text: 'Not Assigned' },
        token: ''
      }
    },
    computed: {
      status () {
        if (this.quote.isQuoteRejected) {
          this.completed = { class: 'badge-danger', text: 'Report Rejected' }
        } else if (this.quote.isReportSent) {
          this.completed = { class: 'badge-info', text: 'Report Sent' }
        } else if (this.quote.isQualityAssured) {
          this.completed = { class: 'badge-primary', text: 'Quality Assured' }
        } else if (this.quote.isReportCompleted) {
          this.completed = { class: 'badge-success', text: 'Report Completed' }
        } else {
          this.completed = { class: 'badge-warning', text: 'Report Pending' }
        }
        if (this.quote.isReportAssigned) {
          this.assigned = { class: 'badge-primary', text: 'Assigned' }
        } else {
          this.assigned = { class: 'badge-warning', text: 'Not Assigned' }
        }

        if (this.quote.queueJumped) {
          this.queue = { class: 'badge-danger', text: 'Priority' }
        } else {
          this.queue = { class: 'badge-warning', text: 'Normal' }
        }
        return { completed: this.completed, queue: this.queue, assigned: this.assigned }
      },
      propertyTypeName () {
        let name = 'default'
        switch (this.quote.propertyType) {
          case 1:
            name = 'Residential'
            break
          case 2:
            name = 'Commercial'
            break
          case 3:
            name = 'Industrial'
            break
        }
        return name
      },
      formData () {
        return JSON.stringify({ quoteUuid: this.quote.uuid })
      },
      dateRequested () {
        return moment(this.quote.createdAt).format('dddd Do of MMMM YYYY hh:mm A')
      },
      dateAssigned () {
        if (this.quote.ActionLogs.length) {
          return moment(this.quote.ActionLogs[0].createdAt).format('dddd Do of MMMM YYYY hh:mm A')
        } else {
          return 'N/A'
        }
      },
      // dateCompleted () {
      //   return this.quote.reportCompletedDate
      //   ? moment(this.quote.reportCompletedDate).format('dddd Do of MMMM YYYY hh:mm A') : ''
      // },
      // dateQualityAssured () {
      //   return this.quote.qualityAssuredDate
      //   ? moment(this.quote.qualityAssuredDate).format('dddd Do of MMMM YYYY hh:mm A') : ''
      // },
      // dateSent () {
      //   return this.quote.reportSentDate
      //   ? moment(this.quote.reportSentDate).format('dddd Do of MMMM YYYY hh:mm A') : ''
      // },
      quote () {
        return {
          QuotePdf: {},
          QuoteType: {},
          Customer: {},
          ...this.object
        }
      },
      hasAdminPrivilege () {
        return this.$user.administrator
      }
    },
    methods: {
      async send () {
        await this.$store.dispatch(SEND_REPORT, this.quote.uuid)
      },
      async reject () {
        await this.$store.dispatch(REJECT_AND_CREATE_QUOTE, this.quote.uuid)
      },
      async assureQuality () {
        await this.$store.dispatch(ASSURE_QUALITY, this.quote.uuid)
      },
      async assignQuote () {
        await this.$store.dispatch(ASSIGN_QUOTE, this.quote.uuid)
      },
      async complete () {
        await this.$store.dispatch(COMPLETE_REPORT, this.quote.uuid)
      },
      report () {
        this.$router.push({ path: '/approvedQuotes/createReport/' + this.quote.uuid })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/ApprovedQuoteRow.vue